export default __webpack_public_path__ + "static/media/thedocks.8f798c70.png";